import React, { useEffect, useState } from 'react';
import _path from 'ramda/src/path';
import Image from './Image';
import resx from '../../utilities/resx';
import { RESX_GLOBAL, MIXPANEL_INTENT } from '../../Constants';
import Mixpanel from '../../API/Mixpanel';

const ZillowWidget = () => {
    const countryList = [224, 38];
    const gateZillowPushFeature = _path(['Environment', 'PushToZillowFeatureGate'], RESAAS);
    const isUltimate = _path(['User2', 'PremiumPlus'], RESAAS);
    const isIntl = !countryList.includes(_path(['User2', 'CountryId'], RESAAS))
    const isCommercial = _path(['Environment', 'Experience'], RESAAS) === 'commercial';
    const learnMoreUrl = isUltimate
        ? 'https://get.resaas.com/coming-soon-listings-find-out-more/'
        : 'https://get.resaas.com/coming-soon-listings-upgrade/';

    return (
        <React.Fragment>
            {!gateZillowPushFeature && !isIntl && !isCommercial ? (
                <aside
                    className="re-container-outer re-container-md re-zillow-widget-container "
                    data-testid="zillowwidget"
                >
                    <Image
                        src="https://content-eecuhxg6gch7hahp.a03.azurefd.net/assets/12bf5bdf-5b6a-4b31-aa53-cea4534060fc.png"
                        alt="Zillow"
                        width={152}
                    />
                    <div className="re-zillow-widget-description">{resx(RESX_GLOBAL, 'ZILLOW_WIDGET_DESCRIPTION')}</div>
                    <a
                        className="re-btn re-btn-full-width re-btn-nospacing re-zillow-widget-btn-color"
                        href={learnMoreUrl}
                        target="_blank"
                    >
                        {resx(RESX_GLOBAL, 'ZILLOW_WIDGET_BUTTON_TEXT')}
                    </a>
                </aside>
            ) : null}
        </React.Fragment>
    );
};

export default ZillowWidget;
